export default "__VITE_ASSET__50ef33d8__"